const moment = require("moment");
/**
 * Format vehicle type
 * @param {*} type type of vehicle 
 * @returns {string} formatted vehicle type 
 */
export function vehicleTypeFormat(type) {
    if (type === "sedan") {
        return "Sedan";
    } else if (type === "boat") {
        return "Boat";
    } else if (type === "coach") {
        return "Coach";
    } else if (type === "limousine") {
        return "Limousine";
    } else if (type === "minibus") {
        return "Minibus";
    } else if (type === "midicoach") {
        return "Midicoach";
    } else if (type === "minivan") {
        return "Minivan";
    } else if (type === "mpv") {
        return "Mpv";
    } else if (type === "pickup") {
        return "Pickup";
    } else if (type === "premium_sedans") {
        return "Premium Sedans";
    } else if (type === "suvs") {
        return "SUVs";
    }
    return "Unknown Type";
}

/**
 * Format category type
 * @param {*} type type of category 
 * @returns {string} formatted category type 
 */
export function formatServiceCategory(type) {
    if (type === "standard") {
        return "Standard Class";
    } else if (type === "business") {
        return "Business Class";
    } else {
        return "Luxury Class";
    }
}

/**
 * Format passenger type
 * @param {*} type type of passenger 
 * @returns {string} formatted passenger type 
 */
export function formatPassengerType(type) {
    if (type === "ADULT") {
        return "Adult";
    } else if (type === "SENIOR") {
        return "Senior";
    } else {
        return "Child";
    }
}

/**
 * Get label to header table based on type
 * @param {*} type type of transport 
 * @returns {string} label for header table
 */
export function getTransportHeaderLabel(type) {
    if (["ARRIVAL", "DEPARTURE"].includes(type)) {
        return "Flight N°";
    } else if (type === "STATION") {
        return "Rail Line";
    } else if (type === "PORT") {
        return "Cruise Ship";
    } else {
        return "Transport Ref.";
    }
}

/**
 * Format passenger table headers
 * @param {*} files list of files
 * @param {*} transferType type of transfer
 * @returns {Array} formatted passenger table headers
 */
export function formatPassengerTableHeaders(files = [], transferType) {
    return files
        .filter(file => {
            if (["HOURLY", "JOURNEY"].includes(transferType)) {
                return file.key !== "itinerary";
            }
            return true;
        })
        .map(file => {
            if (file.key === "itinerary") {
                return { ...file, label: getTransportHeaderLabel(transferType) };
            }
            return file;
        });
}
/**
 * Format transfer type
 * @param {*} type type of transfer 
 * @returns {string} formatted transfer type 
 */
export function formatTransferType(type) {
    if (type === "ARRIVAL") {
        return "Airport Transfer (Arrival)";
    } else if (type === "DEPARTURE") {
        return "Airport Transfer (Departure)";
    } else if (type === "STATION") {
        return "Station Transfer";
    } else if (type === "PORT") {
        return "Port Transfer";
    } else if (type === "HOURLY") {
        return "Hourly";
    } else if (type === "JOURNEY") {
        return "Journey";
    }
    return "";
}

/**
 * Get transfer type label
 * @param {*} type type of transfer 
 * @returns {string} label for transfer type
 */
export function getTransferTypeLabel(type) {
    if (["ARRIVAL", "DEPARTURE"].includes(type)) {
        return "Flight N°:";
    } else if (type === "STATION") {
        return "Rail Line:";
    } else if (type === "PORT") {
        return "Cruise Line:";
    } else if (type === "HOURLY") {
        return "Hours:";
    }
    return "";
}

/**
 * Get source provider name
 * @param {*} source source object 
 * @returns {string} source provider name
 */
export function formatSourceProvider(source) {
    if (source.provider === "RHOMTRIP") {
        return "RhomTrip";
    } else if (source.provider === "VENTRATA") {
        return "Ventrata";
    }
    return "";
}

/**
 * Format quote status
 * @param {*} status status of the quote 
 * @returns {string} formatted quote status 
 */
export function formatQuoteStatus(status) {
    if (status === "NEW") {
        return "New";
    } else if (status === "DRAFT") {
        return "Draft";
    } else if (status === "CANCELLED") {
        return "Cancelled";
    } else if (status === "EXPIRED") {
        return "Expired";
    } else if (status === "REJECTED") {
        return "Rejected";
    }
    return "Unknown Status";
}

/**
 * Round price to two decimals
 * @param {number} price price to round 
 * @returns {number} rounded price 
 */
export function roundToTwoDecimals(price) {
    return parseFloat(price.toFixed(2));
}

/**
 * Format a quote date to "DD-MMM-YYYY" format
 * @param {string} date - The date string to format
 * @returns {string} - The formatted date string
 */
export function formatQuoteDate(date) {
    if (date) {
        return moment.parseZone(date).format("DD-MMM-YYYY");
    }
    return "";
}

/** Format a quote time to "hh:mm A" format
 * @param {string} time - The time string to format
 * @returns {string} - The formatted time string
 */
export function formatQuoteTime(time) {
    return moment(time, ["hh:mm A"]).format("hh:mm A");
}

/** Format customer type
 * @param {*} type type of customer 
 * @returns {string} formatted customer type 
 */
export function formatCustomerType(type) {
    if (type === "customer") {
        return "Customer";
    } else if (type === "travel_agency") {
        return "Travel Agency";
    } else if (type === "business") {
        return "Business";
    } else if (type === "travel_access") {
        return "Agent";
    } else if (type === "guest") {
        return "Guest";
    }
    return "Customer";
}

/** Build passenger title by gender
 * @param {string} gender - The gender of the passenger
 * @returns {string} - The title for the passenger
 */
export function buildPassengerTitleByGender(gender) {
    if (gender === "male") {
        return "Mr.";
    } else if (gender === "female") {
        return "Mrs.";
    }
    return "Mx.";
}

/** Format user position
 * @param {string} type - The position type of the user
 * @returns {string} - The formatted user position
 */
export function formatUserPosition(type) {
    if (type === "administration-finance") {
        return " Administration & Finance";
    } else if (type === "co-founder-cto") {
        return "Co-Founder & CTO";
    } else if (type === "co-founder-coo") {
        return "Co-Founder & COO";
    } else if (type === "co-founder-ceo") {
        return "Co-Founder & CEO";
    } else if (type === "customer-service-representative") {
        return "CSR";
    } else if (type === "data-entry-operator") {
        return "Data Entry Operator";
    } else if (type === "designer-front-end") {
        return "Designer & Front End";
    } else if (type === "developer") {
        return "Developer";
    } else if (type === "junior-reservations-sales-agent") {
        return "Junior Reservations & Sales Agent";
    } else if (type === "product-manager") {
        return "Product Manager";
    } else if (type === "reservations-csr-manager") {
        return "Reservations & CSR Manager";
    } else if (type === "reservations-sales-agent") {
        return "Reservations & Sales Agent";
    } else if (type === "sales-manager") {
        return "Sales Manager";
    } else if (type === "account-manager") {
        return "Account Manager";
    } else if (type == "customer-service-manager") {
        return "Customer Service Manager";
    } else if (type === "customer-service-claims-manager") {
        return "Customer Service & Claims Manager";
    } else {
        return "Unknown";
    }
}

/** Format pickup date to "YYYY-MM-DD" format
 * @param {string} date - The date string to format
 * @returns {string} - The formatted date string
 */
export function formatPickupDate(date) {
    if (date) {
        return moment.parseZone(date).format("YYYY-MM-DD");
    }
    return "";
}


/** Get label for transport based on transfer type
 * @param {string} transferType - The type of transfer
 * @returns {string} - The label for the transport
 */
export function formatLabelTransport(transferType) {
    if (["ARRIVAL", "DEPARTURE"].includes(transferType)) {
        return "Flight N°";
    } else if (transferType === "STATION") {
        return "Rail Line";
    } else if (transferType === "PORT") {
        return "Cruise Ship";
    } else if (transferType === "HOURLY") {
        return "Hours";
    }
    return "";
}